export class ExperimentsEmitter {
    baseUrl;
    token;
    #queue = [];
    constructor(baseUrl, token) {
        this.baseUrl = baseUrl;
        this.token = token;
    }
    assigned(p) {
        this.#queue.push({ ...p, ts: Date.now(), type: 'assigned' });
    }
    exposure(p) {
        this.#queue.push({ ...p, ts: Date.now(), type: 'exposure' });
    }
    goal(p) {
        this.#queue.push({ ...p, ts: Date.now(), type: 'goal' });
    }
    async flush(opts = {}) {
        if (this.#queue.length === 0)
            return;
        const batch = this.#queue.splice(0, this.#queue.length);
        try {
            await fetch(`${this.baseUrl}/api/experiments/v1/events`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(this.token ? { Authorization: `Bearer ${this.token}` } : {}),
                },
                body: JSON.stringify(batch),
                keepalive: !!opts.keepalive,
                credentials: 'include',
            });
        }
        catch {
            // drop silently
        }
    }
}
//# sourceMappingURL=emitter.js.map